import { useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import DataTable from "react-data-table-component";
import separateNumber from "../../../utils/separateur";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import moment from "moment";
import PageHeader from "../../ui/PageHeader";
import SectionCard from "../../ui/SectionCard";
import SearchBox from "../../ui/SearchBox";
import EmptyState from "../../ui/EmptyState";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function TransactionAdvPage(){
  const [dateTime,setDateTime] = useState(new Date()) ;
  const [itemsList,setItemsList] = useState([]);
  const [itemsListFilter,setItemsListFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateDebut,setDateDebut] = useState('');
  const [dateFin,setDateFin] = useState('');


  const columns = [

    {
      name: "MARCHAND RECHARGES",
      selector : row =>(
        <div className="d-flex align-items-center py-1">
          <img src="../../../assets/images/faces-clipart/pic-1.png" alt="" className="rounded-circle me-2" style={{width:28,height:28}} />
          <b>{row.MarchandRecharges}</b>
        </div>
      )
    },

    {
      name: "DATE CREATION",
      selector : row => moment(row.DateCreation).format('Do MMMM YYYY H:m')
    },

    {
      name: "MONTANT",
      selector : row => <b className="text-danger">{separateNumber(row.Montant)}</b>
    },

    // {
    //   name: "TERRITOIRES",
    //   selector : row => row.NomTerritoire,
    // },
    // {
    //   name: "SECTEURS",
    //   selector : row => row.NomSecteur
    // },
    {
      name: "SOLDE",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMomo)}</b>
    },
    {
      name: "SOLDE DEBUT",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMinimumDebut)}</b>
    },
    {
      name: "SOLDE FIN",
      selector : row => <b className="text-dark">{separateNumber(row.SoldeMaximumFin)}</b>
    },

    {
      name: "RETOUR SITE",
      selector : row => <b className="text-success">{separateNumber(row.RetoursSites)}</b>
    },

    // {
    //   name: "STATUT",
    //   selector : row => (
    //     <>
    //      {row.is_active == 1 && (
    //     <span className="badge bg-success">Actif</span>
    //     )}
    //     {row.status == 0 && (
    //         <span className="badge bg-danger">Inactif</span>
    //     )}
    //     </>
    //   )
    // },



];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE TRANSACTION ADV')){
          navigate('/page-no-found');
      }
  },[user]);

  useEffect(()=>{
    fetchItemsList(dateTime);
  },[]);
  const fetchItemsList = async (date_debut,date_fin)=>{
    setLoading(true);
    try {
        axios.post(url.base+'/get_transaction_adv',{date_debut:moment(date_debut).format('YYYY-MM-DD'),date_fin:moment(date_fin).format('YYYY-MM-DD')},{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`

            },
        }).then((resp)=>{

            if(resp.status == 200){
                setItemsList(resp.data);
                setItemsListFilter(resp.data);
            }
            setLoading(false);
        })
    } catch (error) {
        setLoading(false);
    }
}

const handleFilter=(event)=>{
  const datas = itemsListFilter?.filter(row => row.MarchandRecharges.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NumeroRecharges.toLowerCase().includes(event.target.value.toLowerCase()) )  ;
  setItemsList(datas);
}

const handleFilterDate=(event)=>{
  const dateValue = event.target.value;
  if(event.target.value !== ""){
      setDateTime(dateValue);
      setDateFin(dateValue)
      fetchItemsList(dateDebut,dateValue);
  }


}

  const periodeLabel = dateFin === ''
    ? moment(dateTime).format("Do MMMM YYYY")
    : `${moment(dateDebut).format("Do MMMM")} au ${moment(dateFin).format("Do MMMM YYYY")}`;

    return (
        <>
            <ContentPage>
              <PageHeader eyebrow="ADV" title="Transactions ADV" periodLabel={periodeLabel} />

              <div className="col-lg-12 grid-margin stretch-card">
                <SectionCard
                  icon="mdi-swap-horizontal-bold"
                  color="primary"
                  title="Transactions ADV"
                  actions={<ExportExcel excelData={itemsList} filename={"LISTE DES TRANSACTIONS ADV"}  title={"Télécharger"} color={"btn-success"}/>}
                >
                    <div className="filter-toolbar mb-3">
                      <div className="row g-3">
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Rechercher</label>
                          <SearchBox placeholder="Rechercher un marchand..." onChange={handleFilter} />
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Date de début</label>
                          <input type="date" className="form-control" onChange={(e)=>setDateDebut(e.target.value)}/>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Date de fin</label>
                          <input type="date" className="form-control" onChange={handleFilterDate}/>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                    <DataTable
                          columns={columns}
                          data={itemsList}
                          customStyles={customerStyle}
                          pagination
                          selectableRows
                          striped
                          highlightOnHover
                          progressPending={loading}
                          progressComponent={
                              <div className="text-center py-5">
                                  <div className="spinner-border text-primary" role="status"></div>
                              </div>
                          }
                          noDataComponent={<EmptyState icon="mdi-swap-horizontal" title="Aucune transaction trouvée" />}
                          fixedHeaderScrollHeight="70vh"
                      />
                    </div>
                </SectionCard>
              </div>
            </ContentPage>
        </>
    )
}
export default TransactionAdvPage;
